<template>
  <div class="body" id="body">
    
    <div class="header">

      <div class="header_row first_sec">
        
        <div class="wrap">
          <div class="menu ">
            <div class="menu_wrap">
              <div class="logo">
                <a href="#">
                  <img src="./ai.png" alt="">
                </a>
              </div>
              
              <div class="timer">
                <div class="get_started">
                
                <transition v-if="!isRDVisible">
                  <div class="time-wrap">
                    <div class="time-col">
                      <div class="time-tit">{{days}}</div>
                      <div class="time-label">days</div>
                    </div>
                    <div class="time-col">
                      <div class="time-tit">{{hours}}</div>
                      <div class="time-label">hours</div>
                    </div>
                    <div class="time-col">
                      <div class="time-tit">{{minutes}}</div>
                      <div class="time-label">minutes</div>
                    </div>
                    <div class="time-col">
                      <div class="time-tit">{{seconds}}</div>
                      <div class="time-label">seconds</div>
                    </div>
                  </div>
                  <div class="pg rxblocks fixedtime">
                    <div class="ofvwrapper">
                      <div class="wrapper mini">
                        <div class="item_wrapper color131">
                          <div class="item_content_wrapper">
                            <div class="item_content_wrapper_table">
                              <div class="item_content ">
                                <div>
                                  <div>
                                    <div class="bigNumbers days" ref="days1">{{days}}</div>
                                    <div class="smallLabel">days</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="wrapper mini">
                        <div class="item_wrapper color131">
                          <div class="item_content_wrapper">
                            <div class="item_content_wrapper_table">
                              <div class="item_content ">
                                <div>
                                  <div>
                                    <div class="bigNumbers hours" ref="hours1">{{hours}}</div>
                                    <div class="smallLabel">hours</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="wrapper mini">
                        <div class="item_wrapper color131">
                          <div class="item_content_wrapper">
                            <div class="item_content_wrapper_table">
                              <div class="item_content ">
                                <div>
                                  <div>
                                    <div class="bigNumbers minutes" ref="minutes1">{{minutes}}</div>
                                    <div class="smallLabel">minutes</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="wrapper mini ">
                        <div class="item_wrapper color131">
                          <div class="item_content_wrapper">
                            <div class="item_content_wrapper_table">
                              <div class="item_content ">
                                <div>
                                  <div>
                                    <div class="bigNumbers seconds" ref="seconds1">{{seconds}}</div>
                                    <div class="smallLabel">seconds</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 
                </transition> 
                <div class="bt">
                 <a class="start-scroll" href="https://rixtrema.net/requestdemo/index?product=REMAI">Request Demo</a>
                
                </div> 
              </div>
              </div>
            </div>
          </div>

          <div class="header_column">
            <!-- <p class="subTitle mt-50">
              LEGAL FOCUSED SOFTWARE
            </p> -->
            <h1>
              401kAI + AdvisorAI 2.0 for Price of 1: LIMITED TIME Bundle 
            </h1>
            <h2>
              AI you control with financial knowledge you need
            </h2>
            <p class="titleDescr">
              <ul>
                <li>
                  <i class="fas fa-check"></i>
                  <p>
                    Become a master of AI in qualified plan & financial advice

                  </p> 
                </li>
                <li>
                  <i class="fas fa-check"></i>
                  <p>
                    Brand new cutting edge module for working with PDF & photo statements

                  </p>
                </li>
                <li>
                  <i class="fas fa-check"></i>
                  <p>
                    Has the capabilities of ChatGPT, but also knows about finance & 850K retirement plans
                  </p>
                </li>
                <li>
                  <i class="fas fa-check"></i>
                  <p>
                    Completely private
                  </p>
                </li>
                <li>
                  <i class="fas fa-check"></i>
                  <p>
                    Integrated with compliance
                  </p>
                </li>
              </ul>
            </p>
            <div class="btn">
              <a href="https://rixtrema.net/requestdemo/index?product=REMAI">Request Demo</a>
              <!-- <div class="clk-video">
                <div>
                  <img src="./right-svgrepo-com (1).svg" alt="">

                </div>
                <p>Watch Video</p>              
              </div> -->
            </div>
          </div>
          <div class="header_column">         
            <!-- <img class="gif" src="./animation_3.gif"> -->
          <!-- <animation/> -->
          <lottie-animation 
            :width="400"
            path="ANIMATION.json" 
          />
          </div>
        </div>
      </div> 
      
      <div 
        v-observe-visibility="requestDemoVisibilityChanged"
        class="pg rxblocks mrx"
      >
        <div class="work">
          <div class="ofvwrapper">
            <div class="wrapper mini mobw100">
              <div class="item_wrapper color131">
                <div class="item_content_wrapper">
                  <div class="item_content_wrapper_table">
                    <div class="item_content ">
                      <div>
                        <div class="taright">OFFER<br />EXPIRES<br />IN</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper mini">
              <div class="item_wrapper color131">
                <div class="item_content_wrapper">
                  <div class="item_content_wrapper_table">
                    <div class="item_content ">
                      <div>
                        <div>
                          <div class="bigNumbers days" ref="days">{{days}}</div>
                          <div class="smallLabel">days</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper mini">
              <div class="item_wrapper color131">
                <div class="item_content_wrapper">
                  <div class="item_content_wrapper_table">
                    <div class="item_content ">
                      <div>
                        <div>
                          <div class="bigNumbers hours" ref="hours">{{hours}}</div>
                          <div class="smallLabel">hours</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper mini">
              <div class="item_wrapper color131">
                <div class="item_content_wrapper">
                  <div class="item_content_wrapper_table">
                    <div class="item_content ">
                      <div>
                        <div>
                          <div class="bigNumbers minutes" ref="minutes">{{minutes}}</div>
                          <div class="smallLabel">minutes</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper mini ">
              <div class="item_wrapper color131">
                <div class="item_content_wrapper">
                  <div class="item_content_wrapper_table">
                    <div class="item_content ">
                      <div>
                        <div>
                          <div class="bigNumbers seconds" ref="seconds">{{seconds}}</div>
                          <div class="smallLabel">seconds</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>  

      <div id="video" class="header_row video">
        <h2>
          401kAI AdivsorAI 2.0 Breakthrough Tech Spend Minutes Instead of Days
        </h2>
        <div class="video-wrap">
          <iframe 
        src="https://player.vimeo.com/video/866752318?h=942b22316e&title=0&byline=0&portrait=0" 
        width="100%" 
        height="100%" 
        frameborder="0" 
        allow="autoplay; 
        fullscreen; 
        picture-in-picture" 
        allowfullscreen
        ></iframe>
        </div>
      </div>
      <!-- <div class="third-sec header_row">
        <div class="wrap flex-col">

          <div class="img">
            <img src="./img/60d4fe5dea216b5f867916e9_rocket.svg" alt="">
          </div>
          <h2 style="text-align: center">
            AdvisorAI <br>Rule AI instead of fearing it <br>          
          </h2>
          <div class="row">
            <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./01.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">Summarizes all aspects of portfolio risk in one click</div>
            </div>

            <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./02.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">
                Creates custom emails for each lead
              </div>
            </div>

            <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./03.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">
                Learns in detail about lead’s financial situation
              </div>
            </div>

            <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./05.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">
                Knows services you offer to get you a meeting
              </div>
            </div>

            <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./06.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">
                Integrated with your compliance tools
              </div>
            </div>
            
             <div class="item">
              <div class="icon_div">
                <div class="item_icon">
                  <img src="./07.svg" alt="">
                </div>
              </div>
              
              <div class="item_text">
                Create effective calling pitches for a plan
              </div>
            </div> 
            
            
            
          </div>

        </div>
      </div>   -->   
      <div class=" header_row sec_section">
        <div class="wrap">
          <div class="header_row">
            <div class="header_column">
              <!-- <p class="subTitle">
                DIGITAL ONBOARDING
              </p> -->
              <h2>
                AdvisorAI/401kAI 2.0: Do 3 hours of Research in 3 minutes
              </h2>
              <p class="titleDescr">
                Includes brand new module to work with PDF or photo lead statements. You can go from taking a photo of a screen with prospect statement to delivering analysis in 3 minutes.

              </p>
              <div class="bullet_points">
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>10X your turnaround time for prospects</p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Win plans and clients like never before</p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Deliver meaningful research faster and more often to always be top of mind</p>
                  </div>
                  <!-- <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>You have full control over AdvisorAI</p>
                  </div> -->
                </div>
                <div class="bullet_point_col">
                  <!--<div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Knows & uses your professional strengths</p>
                  </div>
                   <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Summarize plan documents</p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Store data for compliance purposes</p>
                  </div> -->
                </div>
                
              </div>
            </div>
            <div class="header_column">
              <!-- <img class="img_for_col" src="./IMG_2076 (1).png" alt=""> -->
              <!-- <iframe 
                src="https://player.vimeo.com/video/866756414?h=942b22316e&title=0&byline=0&portrait=0" 
                width="100%" 
                height="100%" 
                frameborder="0" 
                allow="autoplay; 
                fullscreen; 
                picture-in-picture" 
                allowfullscreen
                ></iframe> -->
                <iframe src="https://player.vimeo.com/video/866756414?h=72864f133a&autoplay=1&loop=1&title=0&byline=0&portrait=0" width="640" height="467" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

            </div>
          </div>
        </div>
      </div>
      <div class=" header_row sec_section">
        <div class="wrap">
          <div class="header_row rev">
            <div class="header_column">
              <!-- <p class="subTitle">
                DIGITAL ONBOARDING
              </p> -->
              <h2>
                Part I of the bundle: 401kAI 2.0 
              </h2>
              <p class="titleDescr">
                401kAI is already used by 60+ firms since its launch only 3.5 months ago. 401kAI 2.0 goes far beyond communication and includes a full PDF or photo client statement analysis. Take a photo of your lead’s 408(b)(2). Get a stunning research report and answer any questions about it in 3 minutes.

              </p>
              <div class="bullet_points">
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Go from prospect PDF or photo to a full research report in 3 minutes
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      10X your communication efficiency
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Write amazing custom emails

                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Create fast and effective calling pitches
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      You have full control over 401kAI™

                    </p>
                  </div> 
                </div>
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Knows & uses your professional strengths</p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Ask any questions about prospects’ or clients’ 408(b)(2)
                    </p>
                  </div>
                   <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Summarize plan documents</p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Store data for compliance purposes</p>
                  </div> 
                </div>
                
              </div>
            </div>
            <div class="header_column">
              <img class="img_for_col" src="./IMG_2076 (1).png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div id="text1"  class=" header_row sec_section">
        <div class="wrap">
          <div class="header_row rev">
            <div class="header_column">
              <!-- <p class="subTitle">
                DIGITAL ONBOARDING
              </p> -->
              <h2>
                Part II of bundle: AdvisorAI 2.0 to 10X your efficiency
              </h2>
              <p class="titleDescr">
                Tools like AdvisorAI are multipliers. They multiply your effort in data analysis and communication. Do 3 hours of research in 3 minutes and always be the first to deliver stunning reports to your clients.
              </p>
              <div class="bullet_points">
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Go from PDF or photo statement to stunning report in 3 minutes
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Get instant answers to your questions about client documents
                    </p>
                  </div>
                  <!-- <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Emails can focus on plan problems, recent legal cases, regulations (none of these ChatGPT can do)
                  </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>Emails can focus on portfolio risks, asset contributors to risk, personal financial situation and risk capacity, advisor competencies
                    </p>
                  </div>                 -->
                </div>     
              </div>
            </div>
            <div class="header_column">
              <h2><b><i>Email writing: </i></b> </h2>
                  
              <div class="text-typing"> 
                        
                <h5> 
                  <span class="typed-text">{{ typeValue2 }}</span>
                  <span class="cursor" :class="{'typing': typeStatus2}">&nbsp;</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class=" header_row sec_section">
        <div class="wrap">
          <div class="header_row ">
            <div class="header_column">
              <!-- <p class="subTitle">
                DIGITAL ONBOARDING
              </p> -->
              <h2>
                AdvisorAI analyzes portfolio risk and client situation in two minutes: offers you an executive summary
              </h2>
              <p class="titleDescr">
                Each summary incorporates investments, contributors to risk, top scenarios where portfolio loses money, and client’s financial situation
              </p>
              <div class="bullet_points">
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      You control the length of the summary
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      You can regenerate summaries focusing on different aspects of risk and client situations
                    </p>
                  </div>
                                
                </div>     
              </div>
            </div>
            <div class="header_column">
              <h2><b><i>Summarize Portfolio & Client </i></b> </h2>          
              <div class="text-typing"> 
                        
                <h5> 
                  <span class="typed-text">{{ typeValue }}</span>
                  <span class="cursor" :class="{'typing': typeStatus}">&nbsp;</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="header_row guarantee">
        <div class="wrap">
          <div class="sec-wrap">
            <div class="caption">
                <h2>100% Money <br> Back Guarantee</h2>
            </div>
            <div class="desc">
              <div class="image">            
                <img
                  src="./img/img-acs.png"
                  style="object-fit: cover"
                />
              </div>

              <div class="ol">
                <ol class="points">
                  <li class="point-new">
                    I guarantee that if you are unhappy with the product or unable to use it, we will return your money instantly any time before October 31<sup>st</sup> , 2023
                  </li>
                  <!-- <li class="point-new">
                    RiXtrema Client Success Team member will prepare and start your 2023 plan sponsor mailings and marketing quizzes before June 10
                  </li> -->
                  <li class="point-new">
                    We are so confident in the product; we are risking major investment of time to guarantee your results
                  </li>
                  <li class="point-new">
                    In 2023 you are going to be in a race against time and other advisors. Do you want to be on a horse buggy or a racecar?
                  </li>
                  <li class="point-new">
                    If you have any questions about the product or our guarantee, call us (212) 513-7070. Ask for me if necessary
                  </li>
              </ol>
              <div class="podp">
                  <p>Daniel Satchkov, President</p>
                  <img src="./img/daniel-sign .png"
                    style="object-fit: cover"
                  />
              </div>
              </div>

              
            </div>
            

            
          </div>
        </div>
      </div>
      <div id="text1"  class=" header_row sec_section">
        <div class="wrap">
          <div class="header_row rev">
            <div class="header_column">
              <!-- <p class="subTitle">
                DIGITAL ONBOARDING
              </p> -->
              <h2>
                ChatCRM: Focus on closing, not endless reading, studying, summarising
              </h2>
              <!-- <p class="titleDescr">
                Every email incorporates specific data about the plan i.e. plan red flags, ratings, deficiences, history of participants and assets
              </p> -->
              <div class="bullet_points">
                <div class="bullet_point_col">
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Creates instant relevant calling pitches for every lead
                    </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Quickly analyze any lead, next action steps, deliverables
                  </p>
                  </div>
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Analyze notes, tasks for particular client in under 2 minutes
                    </p>
                  </div> 
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      Creates superb emails for you to refine and send in minutes
                    </p>
                  </div>  
                  <div class="bullet_point_item">
                    <img src="https://assets.website-files.com/60c7432f93168d7f6dd9c0ef/60c9f99c93975334fc7ae31d_outline-tick-icon.svg" alt="">
                    <p>
                      <b>BONUS</b>: Free CRM with ChatCRM
                    </p>
                  </div>              
                </div>     
              </div>
            </div>
            <div class="header_column">
              <h2><b><i> Lead History Summaries: </i></b> </h2>
                  
              <div class="text-typing"> 
                        
                <h5> 
                  <span class="typed-text">{{ typeValue3 }}</span>
                  <span class="cursor" :class="{'typing': typeStatus3}">&nbsp;</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="prices" class="price header_row">
        <div class="wrap">
          <div class="row">
            <div class="price_column mr-50">
              <!-- <div class="red_line">
                <div class="text">
                  Best Value
                </div>
              </div> -->
              <div class="title_price">
                {{prices.elitePlanAccelerator.name}}

              </div>
              <div class="big_price">
                
                <div class="">
                  Regular Price*: <br> <b>{{prices.elitePlanAccelerator.regularPrice}}</b> 
                </div>
              </div>
              
              <!-- <div class="pr">
                Special Offer: <b>{{prices.elitePlanAccelerator.priceDisplay}}</b> 
              </div> -->
              <div class="line">
                <div class="line_col"></div>
              </div>
              <div class="bullet_poin">
                <!-- <ul>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>Consultants create and launch your online marketing for 2023 ($4,495 Value)</p>
                  </li>
                  <li>
                    <i class="fas fa-globe-americas"></i>
                    <p>
                      Marketing campaign targeting 500 plan sponsors every month starting in mid-January 2023 ($6,995 Value) and will run throughout 2023 (Up to 6000 plan sponsors in 2023)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-dollar-sign"></i>
                    <p>
                      Consultants create landing pages to attract plan sponsors ($600 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-route"></i>
                    <p>
                      Consultants create your special lead magnets using marketing quizzes ($1,200 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>
                      401kFiduciaryOptimizer 3.0 – the software that will help you win audited plans ($4,200 Value)
                    </p>

                  </li>
                </ul> -->
                <h4>Includes:</h4>
                <h5>401kAI:</h5>
                <div class="bonuses">
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      401kAI™ Assistant w/full capability
                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      Search through 850k plans
                    </p>
                  </div>
                </div>  
                <h5>AdvisorAI:</h5>
                <div class="bonuses">
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      AdvisorAI Assistant in Portfolio Crash Testing Light


                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Portfolio Crash Testing Light

                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Analyze risk of portfolios with AdvisorAI


                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Send risk questionnaires

                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      24 hour support
                    </p>
                  </div>
                  <h3>
                    Ideal Starter

                  </h3>                  
                </div>
              </div>
              <div class="but">
                <div class="button" @click="showModal('elitePlanAccelerator')">
                  Get Started Now
                </div>
              </div>
            </div>

            <div class="price_column mr-50">
              <div class="red_line">
                <div class="text">
                  Best Value
                </div>
              </div>
              <div class="title_price">
                {{prices.elitePlanAccelerator2.name}}

              </div>
              <div class="big_price">
                
                <div class="">
                  Regular Price*:<br> <b>{{prices.elitePlanAccelerator2.regularPrice}}</b> 
                </div>
              </div>
              
              <!-- <div class="pr">
                Special Offer: <b>{{prices.elitePlanAccelerator2.priceDisplay}}</b> 
              </div> -->
              <div class="line">
                <div class="line_col"></div>
              </div>
              <div class="bullet_poin">
                <!-- <ul>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>Consultants create and launch your online marketing for 2023 ($4,495 Value)</p>
                  </li>
                  <li>
                    <i class="fas fa-globe-americas"></i>
                    <p>
                      Marketing campaign targeting 500 plan sponsors every month starting in mid-January 2023 ($6,995 Value) and will run throughout 2023 (Up to 6000 plan sponsors in 2023)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-dollar-sign"></i>
                    <p>
                      Consultants create landing pages to attract plan sponsors ($600 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-route"></i>
                    <p>
                      Consultants create your special lead magnets using marketing quizzes ($1,200 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>
                      401kFiduciaryOptimizer 3.0 – the software that will help you win audited plans ($4,200 Value)
                    </p>

                  </li>
                </ul> -->
                <h4>Everything included in Light PLUS </h4>
                <h5>401kAI:</h5>
                <div class="bonuses">
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      Larkspur Executive with 1.2 M executives with contact info ($149/month value) 


                    </p>
                  </div>                  
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      Plan history for all plans
                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                      <!-- <b>Bonus #1</b><br>  -->
                      Daily plan updates
                    </p>
                  </div>
                </div>
                <h5>AdvisorAI:</h5>
                <div class="bonuses">
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                       <b>Bonus #1</b><br>
                      AdvisorAI Assistant in Portfolio Crash Testing 


                    </p>
                  </div> -->
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      ChatCRM Assistant in the CRM (included)

                    </p>
                  </div>
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      Portfolio Crash Testing
                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Analyze risk of portfolios with AdvisorAI

                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Send risk questionnaires


                    </p>
                  </div>    -->
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Risk Capacity reports


                    </p>
                  </div> 
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <b>Bonus #2</b> <br>
                      24 hour support
                    </p>
                  </div>  -->
                  <h3>
                    Accelerate Sales
                  </h3>                 
                </div>
              </div>
              <div class="but">
                <div class="button" @click="showModal('elitePlanAccelerator2')">
                  Get Started Now
                </div>
              </div>
            </div>
            <div class="price_column">
              <!-- <div class="red_line">
                <div class="text">
                  Best Value
                </div>
              </div> -->
              <div class="title_price">
                {{prices.elitePlanAccelerator3.name}}

              </div>
              <div class="big_price">
                
                <div class="">
                  Regular Price*:<br> <b>{{prices.elitePlanAccelerator3.regularPrice}}</b> 
                </div>
              </div>
              
              <!-- <div class="pr">
                Special Offer: <b>{{prices.elitePlanAccelerator3.priceDisplay}}</b> 
              </div> -->
              <div class="line">
                <div class="line_col"></div>
              </div>
              <div class="bullet_poin">
                <!-- <ul>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>Consultants create and launch your online marketing for 2023 ($4,495 Value)</p>
                  </li>
                  <li>
                    <i class="fas fa-globe-americas"></i>
                    <p>
                      Marketing campaign targeting 500 plan sponsors every month starting in mid-January 2023 ($6,995 Value) and will run throughout 2023 (Up to 6000 plan sponsors in 2023)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-dollar-sign"></i>
                    <p>
                      Consultants create landing pages to attract plan sponsors ($600 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-route"></i>
                    <p>
                      Consultants create your special lead magnets using marketing quizzes ($1,200 Value)
                    </p>
                  </li>
                  <li>
                    <i class="fas fa-check"></i>
                    <p>
                      401kFiduciaryOptimizer 3.0 – the software that will help you win audited plans ($4,200 Value)
                    </p>

                  </li>
                </ul> -->
                <h4>Everything included in Silver PLUS </h4>
                <h5>401kAI:</h5>
                <div class="bonuses">
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Larkspur Executive with 3M executives with contact info ($299/month value)
                    </p>
                  </div>
                
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      401kFiduciaryOptimizer ($350/month value)
                    </p>
                  </div>
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Detailed data & savings analysis for ~90K audited plans
                    </p>
                  </div>
                </div>
                <h5>AdvisorAI:</h5>
                
                <div class="bonuses">
                  
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p>
                       <b>Bonus #1</b><br> 
                      AdvisorAI Assistant in Portfolio Crash Testing  PRO


                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <b>Bonus #2</b> <br> 
                      ChatCRM Assistant in the CRM (included)

                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Portfolio Crash Testing


                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Analyze risk of portfolios with AdvisorAI

                    </p>
                  </div> -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Send risk questionnaires


                    </p>
                  </div>    -->
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      Risk Capacity reports


                    </p>
                  </div>  -->
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      Automated risk reporting for all portfolios in excel/API



                    </p>
                  </div> 
                  <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                      <!-- <b>Bonus #2</b> <br> -->
                      RegBIOptimizer for Regulation Best Interest Compliance



                    </p>
                  </div>
                  <!-- <div class="bonus_point">
                    <div class="bonus_title">
                      <i class="fas fa-tasks"></i>
                    </div>
                    <p> 
                       <b>Bonus #2</b> <br> 
                      24 hour support
                    </p>
                  </div> -->
                  
                  <h3>
                    Go after Big Plans

                  </h3>
                </div>
              </div>
              <div class="but">
                <div class="button" @click="showModal('elitePlanAccelerator3')">
                  Get Started Now
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="p">
          *all prices are valid when paid semiannually
        </p>
      </div>
      
    </div>
    <PaymentModal
      v-if="show"
      @closeModal="closeModal"
      :show="show"
      :type="type"
      :price="price"
      :period="period"
      :product="product"
    />
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

// import Vue3Lottie from 'vue3-lottie'
// import 'vue3-lottie/dist/style.css'
// import animation from './animation.vue'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue"
import PaymentModal from '@/components/PaymentModal'

import { setTimeout } from 'timers'; 
import Countdown from "vuejs-countdown";
export default {
  components: {
    PaymentModal,
    VueSlickCarousel,
    LottieAnimation,
    Countdown
    // animation
  },
  data() {
    return {
      isRDVisible: true,
      prices: {
        elitePlanAccelerator: {
          name: ' 401k+AdvisorAI 2.0 Light',
          product: 'LARKSPURADVISORAILIGHT2',
          period: 6,
          price: 594,
          priceDisplay: '$69/month*',
          regularPrice: '$99/month',
          show: false,
          type: 2
        },
        elitePlanAccelerator2: {
          name: '401k+AdvisorAI 2.0 Silver',
          product: 'LARKSPURADVISORAISILVER2',
          period: 6,
          price: 1014,
          priceDisplay: '$169/month*',
          regularPrice: '$169/month',
          show: false,
          type: 2
        },
        elitePlanAccelerator3: {
          name: '401k+AdvisorAI 2.0 Gold',
          product: 'LARKSPURADVISORAIGOLD2',
          period: 6,
          price: 2274,
          priceDisplay: '$299/month*',
          regularPrice: '$379/month',
          show: false,
          type: 2
        },
      },
      product: '',
      period: null,
      show: false,
      type: 0,
      price: 0,
      settings:{
        autoplay: true,
        aitoplaySpeed: 3000,
        pauseOnFocus: true,
        pauseOnHover: true,
        fade: false,
        // useCSS: true,
        arrows: true,
        dots: true,
        rows: 1,
        // "variableWidth": true,
        // "slidesToShow": 1,
        // "slidesToScroll": 1,
        // "swipeToSlide": true,
        
      },
      typeValue: '',
      typeValue2: '',
      typeValue3: '',
      typeStatus: false,
      typeStatus2: false,
      typeStatus3: false,
      typeArray: [
        'Based on the information provided, the portfolio of the investor, Daniel, has a total value of $326,785 and is called "Sample Portfolio 2". The top 5 holdings of the portfolio are WFEAX US, DNLDX US, AWPAX US, OPPAX US, and ACAAX US, with expense ratios ranging from 0.59% to 1.37%. The worst 3 losses from plausible scenarios for the portfolio are Fed Severe Adverse Scenario, Stock & Credit Collapse (2008-like), and Negative Rates Come To US, with losses ranging from -33.3% to -47.3%. The top 3 loss contributors in these scenarios are ACAAX US, ALSRX US, and AWPAX US, with expense ratios ranging from 1.17% to 1.34%.', 
        '', 
        
      ],
      typeArray2:[
        'Dear {Jane Investor}, \n As a financial advisor, I understand that reaching your retirement goals is a top priority. That`s why I wanted to reach out to you and discuss how Rixtrema`s expertise can help you achieve your financial objectives. After analyzing your portfolio, Sample Portfolio 2, I noticed that your top holdings include Wells Fargo Advantage Intl Equity A, Dreyfus Active Midcap A, and Alliancebern Intl Growth A. Additionally, I saw that your portfolio has a long-term return of 7.2% and a yield of 0.9%...'
      ],
      typeArray3:[
        'The last note on David Schimm indicates that Michael Jones, the Controller, is interested in making any changes to their 401(k) plan at the moment. Plan to follow up with him again and send proposals to consider meeting with Jon in the near future. Michael is expecting a full report with red flags after which the meeeting can be set.'
      ],
      typingSpeed: 20,
      typingSpeed2: 20,
      typingSpeed3: 20,
      erasingSpeed: 0,
      erasingSpeed2: 0,
      erasingSpeed3: 0,
      newTextDelay: 500,
      newTextDelay2: 500,
      newTextDelay3: 500,
      typeArrayIndex: 0,
      typeArrayIndex2: 0,
      typeArrayIndex3: 0,
      charIndex: 0,
      charIndex2: 0,
      charIndex3: 0,
      
      days: 0,
      hours: 0, 
      minutes: 0,
      seconds: 0,
      timeend: null


    }
  },
  methods: {
    scroll(){
      this.$refs.prices.scrollIntoView({ behavior: "smooth" })
    },
    requestDemoVisibilityChanged(isRDVisible) {
      console.log('!!!', isRDVisible);
      this.isRDVisible = isRDVisible
    },
    inittimeinterval: function() {
      var EXPIRED_DATE = '2023083000000'

      var dt = this.$route.query.dt

      if (dt) EXPIRED_DATE = dt

      this.timeend = new Date(
        EXPIRED_DATE.slice(0, 4),
        EXPIRED_DATE.slice(4, 6),
        EXPIRED_DATE.slice(6, 8),
        EXPIRED_DATE.slice(8, 10),
        EXPIRED_DATE.slice(10, 12)
      )

      setInterval(this.timeinterval, 1000)
    },
    timeinterval: function() {
      console.log('timeinterval', this.timeend)
      var today = new Date()
      today = Math.floor((this.timeend - today) / 1000)

      var tsec = today % 60
      today = Math.floor(today / 60)
      if (tsec < 0) tsec = '00'
      else if (tsec < 10) tsec = '0' + tsec
      var tmin = today % 60
      today = Math.floor(today / 60)
      if (tmin < 0) tmin = '00'
      else if (tmin < 10) tmin = '0' + tmin
      var thour = today % 24
      today = Math.floor(today / 24)
      if (thour < 0) thour = '00'
      if (today < 0) today = '00'

      this.days = today
      this.seconds = tsec
      this.minutes = tmin
      this.hours = thour
    },
    showModal(id) {
      this.show = true
      console.log('id', id, this.prices[id])
      this.type = this.prices[id].type
      this.price = this.prices[id].price
      this.period = this.prices[id].period;
      this.product = this.prices[id].product;
    },
    closeModal() {
      this.show = false
    },
    pageOffset(){
      console.log(window.pageYOffset);
    },
    showNext() {
        this.$refs.carousel.next()
      },
    showPrev() {
        this.$refs.carousel.prev()
      },
    typeText() {      
        if(this.charIndex < this.typeArray[this.typeArrayIndex].length) {
          // if(!this.typeStatus)
          //   this.typeStatus = true;
          this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
          this.charIndex += 1;
          setTimeout(this.typeText, this.typingSpeed);
        }
        else {
          this.typeStatus = false;
          setTimeout(this.eraseText, this.newTextDelay);
        }
        
      
      },
    eraseText() {
        if(this.charIndex > 0) {
          if(!this.typeStatus)
            this.typeStatus = true;
          this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
          // this.typeValue = 0;
          this.charIndex -= 1;
          setTimeout(this.eraseText, this.erasingSpeed);
        }
        else {
          this.typeStatus = false;
          this.typeArrayIndex += 1;
          if(this.typeArrayIndex >= this.typeArray.length)
            this.typeArrayIndex = 0;
            setTimeout(this.typeText, this.typingSpeed + 1000);
        }
      },
    typeText2() {     
      if(this.charIndex2 < this.typeArray2[this.typeArrayIndex2].length) {
        
        if(!this.typeStatus2)
          this.typeStatus2 = true;
        this.typeValue2 += this.typeArray2[this.typeArrayIndex2].charAt(this.charIndex2);
        this.charIndex2 += 1;
        setTimeout(this.typeText2, this.typingSpeed2);
      }
      else {
        this.typeStatus2 = false;
        setTimeout(this.eraseText2, this.newTextDelay2);
      }
    
    },
    eraseText2() {
        if(this.charIndex2 > 0) {
          if(!this.typeStatus2)
            this.typeStatus2 = true;
          this.typeValue2 = this.typeArray2[this.typeArrayIndex2].substring(0, this.charIndex2 - 1);
          // this.typeValue = 0;
          this.charIndex2 -= 1;
          setTimeout(this.eraseText2, this.erasingSpeed2);
        }
        else {
          this.typeStatus2 = false;
          this.typeArrayIndex2 += 1;
          if(this.typeArrayIndex2 >= this.typeArray2.length)
            this.typeArrayIndex2 = 0;
            setTimeout(this.typeText2, this.typingSpeed2 + 1000);
        }
      },
    typeText3() {     
      if(this.charIndex3 < this.typeArray3[this.typeArrayIndex3].length) {
        
        if(!this.typeStatus3)
          this.typeStatus3 = true;
        this.typeValue3 += this.typeArray3[this.typeArrayIndex3].charAt(this.charIndex3);
        this.charIndex3 += 1;
        setTimeout(this.typeText3, this.typingSpeed3);
      }
      else {
        this.typeStatus3 = false;
        setTimeout(this.eraseText3, this.newTextDelay3);
      }    
    },
    eraseText3() {
        if(this.charIndex3 > 0) {
          if(!this.typeStatus3)
            this.typeStatus3 = true;
          this.typeValue3 = this.typeArray3[this.typeArrayIndex3].substring(0, this.charIndex3 - 1);
          // this.typeValue = 0;
          this.charIndex3 -= 1;
          setTimeout(this.eraseText3, this.erasingSpeed3);
        }
        else {
          this.typeStatus3 = false;
          this.typeArrayIndex3 += 1;
          if(this.typeArrayIndex3 >= this.typeArray3.length)
            this.typeArrayIndex3 = 0;
            setTimeout(this.typeText3, this.typingSpeed3 + 1000);
        }
      },

  },
  created() {
    setTimeout(this.typeText, this.newTextDelay + 200);
    setTimeout(this.typeText2, this.newTextDelay2 + 200);
    setTimeout(this.typeText3, this.newTextDelay3 + 200);

  },
  mounted(){
    this.inittimeinterval()
  },
  computed: {
    videoElement () {
      return this.$refs.video;
    }, 
  },
  watch:{
    height1(){
      if((document.getElementById('text1').getBoundingClientRect().top + window.pageYOffset) < window.pageYOffset){
        this.typeStatus = true;
        console.log('negger')
      }
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="sass" src="./blocks.sass"></style>


